module.exports = {"Administración de usos de insumo":"Administración de usos de insumo","Listado de usos de insumo":"Listado de usos de insumo","Ver uso de insumo":"Ver uso de insumo","Editar uso de insumo":"Editar uso de insumo","Nuevo uso de insumo":"Nuevo uso de insumo","Descripción":"Descripción","Estado":"Estado","Producto":"Producto","Código":"Código","Cantidad":"Cantidad","Cantidad Utilizada":"Cantidad Utilizada","Fecha Alta":"Fecha Alta","Fecha Baja":"Fecha Baja","Eliminar":"Eliminar"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/usos-insumo/es.json
// module id = 1202
// module chunks = 0